import React from "react";
import styled from "styled-components";
import { colors } from "../utils/helpers";
import {primeraMay, lluviaRojo} from "../utils/helpers";

// import 'owfont/css/owfont-regular.css';
// import './index.scss';

const TiempoCont = styled.div`
	display: flex;
	justify-content: space-between;
	align-content: center;
	border-bottom: 1px solid ${colors.grisclaro};
	width: 100%;
	padding-top: 1em;
	padding-bottom: 0.2em;
`;

const Hora = styled.h2`
			margin: 0;
			padding: 0.1em 0;
		`;

const Icono = styled.div`
			width: 90px;
			text-align: center;
			min-height: 70px;
			flex-grow: 2;
		`;

const Descripcion = styled.div`
			font-weight: 300;
			padding-bottom: 1em;
		`;

const TiempoDesc = styled.div`
			width: 49px;
			font-weight: 300;
			flex-basis: 4;
			flex-grow: 4;
			padding: 0 1em 0 1em;
		`;

const Temperatura = styled.h2`
			margin: 0;
			padding: 0.1em 0;
		`;


const SVGIcon = styled.div`
			padding-right: 0.4em;
			display: inline-block;
			vertical-align: middle;
		`;


const Forecast1 = props => (
	<TiempoCont>
	<Hora>{props.date.format("HH:mm")}</Hora>
		<Icono className="weather">
			<i className={`wi wi-owm-${props.weather.id}`} />
		</Icono>
	<TiempoDesc>
			<Temperatura className="temperature">
			<span>{Math.round(props.temp)}ºC</span>
		</Temperatura>
		<Descripcion>
			{lluviaRojo(props.weather.description) ? <SVGIcon> <svg width='14' height='14' viewBox='0 0 16 16' fill={colors.main}><path d='M8 1L0 15h16L8 1zm-.8 5h1.5v1.4L8.3 11h-.8l-.4-3.6V6h.1zm.8 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z'></path></svg> </SVGIcon>: '' }
						<span>{primeraMay(props.weather.description)}</span>
						
		</Descripcion>
	</TiempoDesc>
	</TiempoCont>
);

export default Forecast1;



// WEBPACK FOOTER //
// ./src/components/Forecast1.js